import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const TextColor = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M7.46342 18.5L9.00432 14.1615H15.1979L16.7388 18.5H18.6836L13.0585 3.18072H11.1436L5.51858 18.5H7.46342ZM9.58777 12.5159L12.0412 5.60428H12.1609L14.6144 12.5159H9.58777Z"
        fill={color}
      />
    </svg>
  )
})

export default TextColor
